module.exports = __webpack_public_path__ + "static/media/dispatch_systemmoduleC-icon2.0a429be3.png";